import * as Yup from 'yup';

const EVENT_SCHEMA = Yup.object().shape({
  title: Yup.string().required('Required'),
  eventUrl: Yup.string().nullable(),
  date: Yup.date().required('Required'),
  startAt: Yup.string().required('Required'),
  endAt: Yup.string().required('Required'),
  guests: Yup.array(
    Yup.object()
      .shape({
        emailAddress: Yup.string().required('Required'),
        firstName: Yup.string().nullable(),
        lastName: Yup.string().nullable(),
        phoneNumber: Yup.string().nullable(),
      })
      .required(),
  )
    .min(1, 'Guest is required to have atleast 1 attendee')
    .required('Required'),
  content: Yup.string(),
  notifyBefore: Yup.number().required('Required'),
  type: Yup.string().required('Required'),
  location: Yup.string().when('type', ([type], schema) => {
    return type === 'EVENT' ? schema.required('Required') : schema.nullable();
  }),
  tagId: Yup.array().of(Yup.string()),
});

export type EVENT_FORM = Yup.InferType<typeof EVENT_SCHEMA>;

const BOOKING_SCHEMA = Yup.object().shape({
  title: Yup.string().required('Required'),
  tokenId: Yup.string().required('Required'),
  expiresAt: Yup.date().nullable(),
  durationType: Yup.string().oneOf(['minutes', 'hours']).required('Required'),
  duration: Yup.number()
    .when('durationType', ([durationType], schema) => {
      return durationType === 'hours'
        ? schema
            .min(1, 'Duration must be at least 1 hour')
            .max(8, 'Duration cannot exceed 8 hours')
        : schema
            .min(15, 'Duration must be at least 15 minutes')
            .max(480, 'Duration cannot exceed 480 minutes');
    })
    .required('Required'),
  content: Yup.string(),
  notifyBefore: Yup.number().required('Required'),
});

export type BOOKING_FORM = Yup.InferType<typeof BOOKING_SCHEMA>;

const CLIENT_BOOKING_SCHEMA = Yup.object().shape({
  firstName: Yup.string().required('First name required'),
  lastName: Yup.string().required('Last name required'),
  emailAddress: Yup.string().required('Email address required'),
  contactNumber: Yup.string().required('Contact number required'),
  selectedDate: Yup.string().nullable(),
  startAt: Yup.object({
    bookingTime: Yup.string(),
    bookingDate: Yup.string(),
    bookingTimezone: Yup.string(),
    convertedTime: Yup.string(),
    convertedDate: Yup.string(),
    convertedTimezone: Yup.string(),
    unix: Yup.number(),
  }).nullable(),
});
export type CLIENT_BOOKING_FORM = Yup.InferType<typeof CLIENT_BOOKING_SCHEMA>;

const CLIENT_PUBLIC_BOOKING_SCHEMA = Yup.object().shape({
  selectedDate: Yup.string().nullable(),
  startAt: Yup.number().nullable(),
});
export type CLIENT_PUBLIC_BOOKING_FORM = Yup.InferType<
  typeof CLIENT_PUBLIC_BOOKING_SCHEMA
>;

const CLIENT_BOOKING_STEPS = {
  form: 'form',
  review: 'review',
  success: 'success',
  failed: 'failed',
  expired: 'expired',
};

export {
  EVENT_SCHEMA,
  BOOKING_SCHEMA,
  CLIENT_BOOKING_SCHEMA,
  CLIENT_BOOKING_STEPS,
  CLIENT_PUBLIC_BOOKING_SCHEMA,
};
